import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { OnboardingScreen } from './pages/OnboardingScreen';
import { FormScreen } from './pages/FormScreen';
import { pages } from './data/pages';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fa8855yeuq5d">
      <Layout data-id="element-1" data-mp="3fbt3uywgof4t">
        <Routes data-id="element-2" data-mp="3fb19tsiiipgn">
          <Route path="/" element={<Navigate to={`/${pages[0].slug}`} replace data-id="element-4" data-mp="2rknnmimlzktz" />} data-id="element-3" data-mp="3f8f2ntzjabyy" />
          <Route path="/:slug" element={<OnboardingScreen data-id="element-6" data-mp="2mlua4q7bnttt" />} data-id="element-5" data-mp="2rl6vt7mgiuut" />
          <Route path="/:slug/form" element={<FormScreen data-id="element-8" data-mp="2mnnhy8to8k3e" />} data-id="element-7" data-mp="2mmlwdaf14f7f" />
          <Route path="*" element={<Navigate to={`/${pages[0].slug}`} replace data-id="element-10" data-mp="31b8lg3ugklbu" />} data-id="element-9" data-mp="31aqdi9yfoio3" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}